import React from "react";
import MainLayout from "../mainlayout/MainLayout";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import ViewTask from "../modal/ViewTask";
import Modal from "../modal/Modal";

const getStatusColor = (status) => {
  if (status === "Pending") return "border-red-500";
  if (status === "Progress") return "border-yellow-500";
  return "border-green-500";
};

export default function Goal() {
  let [plans, setPlans] = useState([]);
  let [tasks, setTasks] = useState([]);
  let [task, setTask] = useState({});
  let [count, setCount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  let [completeCount, setCompleteCount] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        let res = await fetch(`${process.env.REACT_APP_NODEURL}/getPlans`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({}),
        });
        let result = await res.json();
        if (result.msg == "success") {
          setTasks([...result.tasks]);
          setPlans([...result.plan]);
        }
      } catch (error) {
        console.error("Error fetching plans:", error);
      }
    })();
  }, []);

  const statusCategories = {
    Pending: [],
    Progress: [],
    Completed: [],
  };

  tasks.forEach((task) => {
    if (plans.length > 0) {
      if (plans[0]._id == task.goal) {
        if (task.status === "Completed") ++completeCount;
        statusCategories[task.status].push(task);
        ++count;
      }
    }
  });

  const viewTask = (task) => {
    setTask({
      task: task.tasks,
      id: task._id,
      status: task.status,
      resources: task.resources,
      startTime: task.startTime,
      endTime: task.endTime,
    });
    setIsModalOpen1(true);
  };

  const add = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen1(false);
  };

  const updateTaskInState = (updatedTask, del) => {
    if (del == true) {
      setTasks((prev) => prev.filter((task) => task._id != updatedTask));
    } else if (del == false) {
      setTasks((prev) =>
        prev.map((task) =>
          task._id == updatedTask._id ? { ...task, ...updatedTask } : task
        )
      );
    }
  };

  const handleDelete = async () => {
    if (plans.length > 0) {
      if (window.confirm("Are you sure you want to delete this Plan?")) {
        let res = await fetch(`${process.env.REACT_APP_NODEURL}/deletePlan`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ planId: plans[0]._id }),
        });
        let ans = await res.json();
        if (ans.msg === "success") {
          let deletedPlan = plans[0]._id;
          setPlans((prev) => prev.filter((plan) => plan._id != deletedPlan));
        }
      }
    }
  };

  const percentComplete = Math.round((completeCount / count) * 100);

  return (
    <MainLayout>
      <div className="min-h-screen bg-black text-white p-8">
        {plans.length > 0 ? (
          <>
            <select
              className="text-white bg-black text-xl md:text-2xl font-bold mb-2 p-2 rounded"
              value={plans[0].plan}
              onChange={(e) => {
                const selected = plans.find((p) => p.plan === e.target.value);
                setPlans([
                  selected,
                  ...plans.filter((p) => p.plan !== selected.plan),
                ]);
              }}
            >
              {plans.map((p, index) => (
                <option key={index} value={p.plan}>
                  {p.plan}
                </option>
              ))}
            </select>

            {/* Display Start and End Date */}
            <p className="text-white text-base md:text-lg mb-6">
              📅 <span className="font-semibold">Start:</span>{" "}
              {new Date(plans[0].start).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })}{" "}
              | <span className="font-semibold">End:</span>{" "}
              {new Date(plans[0].end).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })}
            </p>
          </>
        ) : (
          <h1 className="text-3xl font-bold mb-6">
            🎯 {plans[0]?.plan || "No Plan Available"}
          </h1>
        )}

        <button
          onClick={handleDelete}
          className="px-4 py-2 m-1 float-right text-sm rounded-md text-red-400 hover:text-red-300 hover:bg-red-900/30 transition-colors border border-red-900/50"
        >
          Delete Plan
        </button>
        <button
          onClick={add}
          className="px-4 py-2 m-1 float-right text-sm rounded-md text-purple-400 hover:text-purple-300 hover:bg-purple-900/30 transition-colors border border-purple-900/50"
        >
          Add Task
        </button>
        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-2">Completion</h2>
          <div className="w-full bg-gray-700 h-4 rounded-full overflow-hidden">
            <div
              className="bg-green-500 h-4"
              style={{ width: `${percentComplete}%` }}
            />
          </div>
          <p className="mt-1 text-sm text-gray-400">
            {percentComplete}% completed
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {["Pending", "Progress", "Completed"].map((status) => (
            <div key={status}>
              <h3 className="text-xl capitalize font-semibold mb-4">
                {status}
              </h3>
              <motion.div
                className="space-y-3"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                {statusCategories[status].length === 0 ? (
                  <p className="text-gray-500">No tasks</p>
                ) : (
                  statusCategories[status].map((task, index) => (
                    <div
                      key={index}
                      className={`p-4 rounded-xl border-l-4 ${getStatusColor(
                        task.status
                      )} bg-gray-900 shadow`}
                      onClick={() => viewTask(task)}
                    >
                      {task.tasks}
                    </div>
                  ))
                )}
              </motion.div>
            </div>
          ))}
        </div>
      </div>
      <ViewTask
        isOpen={isModalOpen1}
        task={task}
        onClose={handleCloseModal}
        onSave={updateTaskInState}
      />
      <Modal
        isOpen={isModalOpen}
        onSave={(newTask) => {
          setTasks([...tasks, newTask]);
          setIsModalOpen(false);
        }}
        isPlan={plans.length > 0 ? plans[0]._id : ""}
        onClose={() => setIsModalOpen(false)}
        selectedDate={selectedDate}
      />
    </MainLayout>
  );
}
